// extracted by mini-css-extract-plugin
export default {"logo":"PY7XaYoBcA_static-pages","monochrome":"TdvmFBObx9_static-pages","invert":"GKTWjX8VsJ_static-pages"};